const config = require('./config.json')
const development = require('./config.develop.json')
const qa = require('./config.qa.json')
const uat = require('./config.uat.json')
const production = require('./config.production.json')

module.exports = { config, development, qa, uat, production }
